<template>
  <div class="panel-modal-content px-6 py-4">
    <slot />
  </div>
</template>

<script>
export default {
  //
}
</script>
